import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NO_IMAGE_URL } from 'config/constants';
import { PackItemImage } from 'ui/components';

import './SoloItemPackage.scss';

const NO_IMAGE = 'no_image_large';

export default class SoloItemPackage extends Component {
	static propTypes = {
		imageUrl: PropTypes.string.isRequired,
		itemName: PropTypes.string.isRequired,
		itemNumber: PropTypes.string.isRequired,
		itemBaseNumber: PropTypes.string,
		isConfigurable: PropTypes.bool,
	};

	static defaultProps = {
		itemBaseNumber: '',
		isConfigurable: false,
	};

	hasImage(url) {
		if (url) {
			return !url.includes(NO_IMAGE);
		}

		return false;
	}

	render() {
		const { itemName, itemNumber, itemBaseNumber, isConfigurable } = this.props;

		const imageUrl = this.hasImage(this.props.imageUrl)
			? this.props.imageUrl
			: NO_IMAGE_URL;

		return (
			<div className="SoloItemPackage">
				<PackItemImage imageUrl={imageUrl} name={itemNumber} />
				{'  '} {isConfigurable ? itemBaseNumber : itemNumber} - {itemName}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/SoloItemPackage/index.js